/* Vec2STL storefront pipeline (Python, runs in Pyodide). Generated -- edit pipeline_web.py / configurator_core.py instead. */
window.VEC2STL_PY = {
"pipeline_web.py": String.raw`import numpy as np
from shapely.geometry import Polygon, MultiPolygon, LineString
from shapely.ops import unary_union

def skeletonize_mask(mask):
    from skimage.morphology import skeletonize
    return skeletonize(mask)

def skeleton_to_polylines(skel, min_branch_length_px=6):
    ys, xs = np.nonzero(skel)
    if len(xs) == 0:
        return []
    H, W = skel.shape
    _skel = skel

    def neighbors(p):
        x, y = p
        for dx in (-1, 0, 1):
            for dy in (-1, 0, 1):
                if dx == 0 and dy == 0:
                    continue
                nx, ny = (x + dx, y + dy)
                if 0 <= nx < W and 0 <= ny < H and _skel[ny, nx]:
                    yield (nx, ny)
    from scipy.ndimage import convolve as _convolve
    _k = np.array([[1, 1, 1], [1, 0, 1], [1, 1, 1]], dtype=np.uint8)
    _deg_arr = _convolve(skel.astype(np.uint8), _k, mode='constant', cval=0)

    class _DegLookup:

        def get(self, p, default=0):
            x, y = p
            if 0 <= x < W and 0 <= y < H and _skel[y, x]:
                return int(_deg_arr[y, x])
            return default

        def __getitem__(self, p):
            return self.get(p, 0)

        def keys(self):
            return zip(xs.tolist(), ys.tolist())
    degree = _DegLookup()
    visited_edges = set()
    polylines = []

    def edge_key(a, b):
        return (a, b) if a < b else (b, a)
    _dv = _deg_arr[ys, xs]
    _sel = _dv != 2
    endpoints_and_junctions = list(zip(xs[_sel].tolist(), ys[_sel].tolist()))
    if not endpoints_and_junctions:
        endpoints_and_junctions = [(int(xs[0]), int(ys[0]))]
    for start in endpoints_and_junctions:
        for nb in neighbors(start):
            ek = edge_key(start, nb)
            if ek in visited_edges:
                continue
            path = [start, nb]
            visited_edges.add(ek)
            prev, cur = (start, nb)
            while degree.get(cur, 0) == 2:
                nxts = [n for n in neighbors(cur) if n != prev]
                if not nxts:
                    break
                nxt = nxts[0]
                ek2 = edge_key(cur, nxt)
                if ek2 in visited_edges:
                    break
                visited_edges.add(ek2)
                path.append(nxt)
                prev, cur = (cur, nxt)
            if len(path) >= 2:
                length = sum((((path[i][0] - path[i - 1][0]) ** 2 + (path[i][1] - path[i - 1][1]) ** 2) ** 0.5 for i in range(1, len(path))))
                start_deg = degree.get(path[0], 0)
                end_deg = degree.get(path[-1], 0)
                is_dead_end_stub = start_deg == 1 or end_deg == 1
                if not is_dead_end_stub or length >= min_branch_length_px:
                    polylines.append(path)
    return polylines

def smooth_polyline(line, smoothing_px, resample_spacing_px):
    import numpy as np
    from scipy.interpolate import splprep, splev
    from shapely.geometry import LineString as _LS
    coords = np.asarray(line.coords)
    if len(coords) < 4:
        return line
    keep = np.ones(len(coords), dtype=bool)
    keep[1:] = np.abs(np.diff(coords, axis=0)).sum(axis=1) > 1e-09
    coords = coords[keep]
    if len(coords) < 4:
        return line
    is_closed = np.abs(coords[0] - coords[-1]).sum() < 1e-09
    try:
        k = min(3, len(coords) - 1)
        tck, u = splprep([coords[:, 0], coords[:, 1]], s=smoothing_px * len(coords), k=k, per=1 if is_closed else 0)
        max_angle = 0.0175
        dense = np.linspace(0, 1, max(64, min(20000, int(line.length * 2))))
        dx, dy = splev(dense, tck, der=1)
        ddx, ddy = splev(dense, tck, der=2)
        speed = np.hypot(dx, dy)
        speed_safe = np.maximum(speed, 1e-09)
        curvature = np.abs(dx * ddy - dy * ddx) / speed_safe ** 3
        xs_d, ys_d = splev(dense, tck)
        seg = np.hypot(np.diff(xs_d), np.diff(ys_d))
        arc = np.concatenate([[0.0], np.cumsum(seg)])
        total = arc[-1]
        if total <= 0:
            return line
        spacing = np.where(curvature > 1e-12, max_angle / np.maximum(curvature, 1e-12), np.inf)
        spacing = np.clip(spacing, max(resample_spacing_px, 0.3), 20.0)
        density = 1.0 / spacing
        dens_mid = 0.5 * (density[1:] + density[:-1])
        cum = np.concatenate([[0.0], np.cumsum(dens_mid * np.diff(arc))])
        n_pts = int(np.floor(cum[-1]))
        if n_pts < 3:
            picks = np.array([0.0, total])
        else:
            picks = np.interp(np.arange(n_pts + 1), cum, arc)
            picks[-1] = total
        unew = np.interp(picks, arc, dense)
        xs, ys = splev(unew, tck)
        smoothed = _LS(np.column_stack([xs, ys]))
        if smoothed.length > line.length * 3 or smoothed.length < line.length * 0.3:
            return line
        return smoothed
    except Exception:
        return line

def drop_degenerate_vertices(polygons, min_edge_px=0.01):
    from shapely.geometry import Polygon as _P, MultiPolygon as _MP

    def clean_ring(coords):
        pts = list(coords)
        closed = pts[0] == pts[-1]
        if closed:
            pts = pts[:-1]
        out = []
        for pt in pts:
            if out:
                dx = pt[0] - out[-1][0]
                dy = pt[1] - out[-1][1]
                if (dx * dx + dy * dy) ** 0.5 < min_edge_px:
                    continue
            out.append(pt)
        while len(out) > 3:
            dx = out[0][0] - out[-1][0]
            dy = out[0][1] - out[-1][1]
            if (dx * dx + dy * dy) ** 0.5 < min_edge_px:
                out.pop()
            else:
                break
        if len(out) < 3:
            return None
        return out + [out[0]]
    geoms = polygons.geoms if hasattr(polygons, 'geoms') else [polygons]
    out_polys = []
    for g in geoms:
        ext = clean_ring(g.exterior.coords)
        if ext is None:
            continue
        ints = []
        for it in g.interiors:
            r = clean_ring(it.coords)
            if r is not None:
                ints.append(r)
        try:
            np_ = _P(ext, ints)
            if not np_.is_valid:
                np_ = np_.buffer(0)
            if not np_.is_empty:
                if np_.geom_type == 'Polygon':
                    out_polys.append(np_)
                else:
                    out_polys.extend([q for q in np_.geoms if q.geom_type == 'Polygon'])
        except Exception:
            out_polys.append(g)
    if not out_polys:
        return polygons
    return _MP(out_polys) if len(out_polys) > 1 else _MP([out_polys[0]])

def skeletonize_lineart_web(bw_image_path_or_array, target_line_weight_mm, px_to_mm, min_branch_length_px=6, min_feature_mm=None, min_print_resolution_mm=0.1, junctions_out=None):
    if isinstance(bw_image_path_or_array, np.ndarray):
        mask = bw_image_path_or_array
    else:
        from PIL import Image as PILImage
        img = PILImage.open(bw_image_path_or_array).convert('L')
        mask = np.array(img) < 128
    skel = skeletonize_mask(mask)
    if not skel.any():
        raise ValueError('Skeletonization produced an empty result -- check threshold/input image.')
    effective_weight_mm = target_line_weight_mm
    if min_feature_mm is not None and target_line_weight_mm < min_feature_mm:
        effective_weight_mm = min_feature_mm
    half_width_px = effective_weight_mm / px_to_mm / 2.0
    resolution_px = min_print_resolution_mm / px_to_mm
    jitter_simplify_px = resolution_px / 6.0
    spline_smoothing_px = 0.5
    spline_resample_px = max(resolution_px, 0.5)
    circumference_px = 2 * np.pi * half_width_px
    quad_segs = max(3, round(circumference_px / resolution_px / 4))
    min_length_for_shape_px = half_width_px * 2 * 1.5
    effective_min_branch_length_px = max(min_branch_length_px, min_length_for_shape_px)
    if junctions_out is not None:
        from scipy.ndimage import convolve
        kk = np.array([[1, 1, 1], [1, 0, 1], [1, 1, 1]], dtype=np.uint8)
        nb = convolve(skel.astype(np.uint8), kk, mode='constant', cval=0)
        jy, jx = np.nonzero(skel & (nb >= 3))
        junctions_out.extend(zip(jx.tolist(), jy.tolist()))
    polylines = skeleton_to_polylines(skel, effective_min_branch_length_px)
    if not polylines:
        raise ValueError('No strokes survived skeletonization -- min_branch_length_px may be too high.')
    return build_strokes_from_polylines(polylines, half_width_px, jitter_simplify_px, spline_smoothing_px, spline_resample_px, quad_segs)

def build_strokes_from_polylines(polylines, half_width_px, jitter_simplify_px, spline_smoothing_px, spline_resample_px, quad_segs):
    strokes = []
    for path in polylines:
        line = LineString(path)
        line = smooth_polyline(line, spline_smoothing_px, spline_resample_px)
        if len(line.coords) < 2:
            continue
        strokes.append(line.buffer(half_width_px, cap_style='flat', join_style='round', quad_segs=quad_segs))
    if not strokes:
        raise ValueError('No strokes survived skeletonization.')
    merged = unary_union(strokes)
    if isinstance(merged, Polygon):
        merged = MultiPolygon([merged])
    return merged

def check_thin_features(design_union, min_width_px):
    half = min_width_px / 2.0
    eroded = design_union.buffer(-half, join_style=1)
    opened = eroded.buffer(half, join_style=1)
    thin_regions = design_union.difference(opened)
    return (thin_regions, opened)

def thin_feature_report(thin_regions, px_to_mm, min_width_mm):
    if thin_regions.is_empty:
        return {'has_thin_features': False, 'count': 0, 'total_area_mm2': 0.0, 'message': None}
    geoms = thin_regions.geoms if hasattr(thin_regions, 'geoms') else [thin_regions]
    geoms = [g for g in geoms if g.area * px_to_mm ** 2 > 0.01]
    total_area_mm2 = sum((g.area for g in geoms)) * px_to_mm ** 2
    count = len(geoms)
    return {'has_thin_features': count > 0, 'count': count, 'total_area_mm2': round(total_area_mm2, 2), 'message': f'{count} region(s) thinner than {min_width_mm:.2f}mm ({total_area_mm2:.2f}mm² total).'}

def thicken_thin_features(design_union, thin_regions, min_width_px, min_region_area_px=None):
    import math
    if thin_regions.is_empty:
        return design_union
    if min_region_area_px is None:
        min_region_area_px = math.pi * (min_width_px / 4.0) ** 2
    geoms = thin_regions.geoms if hasattr(thin_regions, 'geoms') else [thin_regions]
    real_thin = [g for g in geoms if g.area >= min_region_area_px]
    if not real_thin:
        return design_union
    pad = min_width_px / 2.0
    thickened_thin = unary_union(real_thin).buffer(pad, join_style=1)
    result = unary_union([design_union, thickened_thin])
    result = result.buffer(0)
    result = result.simplify(0.5, preserve_topology=True)
    if isinstance(result, Polygon):
        result = MultiPolygon([result])
    return result

def fillet_junctions(polygons, radius_px, junction_points=None, quad_segs=2):
    if radius_px <= 0:
        return polygons
    closed = polygons.buffer(radius_px, join_style=1, quad_segs=quad_segs).buffer(-radius_px, join_style=1, quad_segs=quad_segs)
    if junction_points:
        from shapely.geometry import MultiPoint
        mask = MultiPoint(list(junction_points)).buffer(radius_px * 2.5, quad_segs=quad_segs)
        closed = polygons.union(closed.intersection(mask))
    if closed.is_empty:
        return polygons
    if isinstance(closed, Polygon):
        closed = MultiPolygon([closed])
    return closed

def add_brim(polygons, brim_width_px, follow_silhouette=False, closing_radius_px=None):
    design_union = unary_union(polygons)
    if not follow_silhouette:
        whole_design_hull = design_union.convex_hull
        brim_shape = whole_design_hull.buffer(brim_width_px, join_style='round', resolution=8)
        return (brim_shape, design_union)
    if closing_radius_px is None:
        minx, miny, maxx, maxy = design_union.bounds
        closing_radius_px = max(maxx - minx, maxy - miny) * 0.02
    closed = design_union.buffer(closing_radius_px, join_style=1).buffer(-closing_radius_px, join_style=1)
    closed_pieces = closed.geoms if hasattr(closed, 'geoms') else [closed]
    silhouette_pieces = [Polygon(p.exterior) for p in closed_pieces if not p.is_empty]
    if len(silhouette_pieces) > 1:
        silhouette = unary_union([p.convex_hull for p in silhouette_pieces])
    else:
        silhouette = silhouette_pieces[0] if silhouette_pieces else design_union.convex_hull
    brim_shape = silhouette.buffer(brim_width_px, join_style='round', resolution=8)
    return (brim_shape, design_union)

def _cross(o, a, b):
    return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0])

def _point_in_triangle(p, a, b, c):
    d1 = _cross(a, b, p)
    d2 = _cross(b, c, p)
    d3 = _cross(c, a, p)
    has_neg = d1 < 0 or d2 < 0 or d3 < 0
    has_pos = d1 > 0 or d2 > 0 or d3 > 0
    return not (has_neg and has_pos)

def _bridge_holes(exterior, holes):
    ring = list(exterior)
    if ring[0] == ring[-1]:
        ring = ring[:-1]
    remaining_holes = [list(h[:-1]) if h[0] == h[-1] else list(h) for h in holes]
    remaining_holes.sort(key=lambda h: -max((pt[0] for pt in h)))
    for hole in remaining_holes:
        if len(hole) < 3:
            continue
        hole_start_idx = max(range(len(hole)), key=lambda i: hole[i][0])
        hp = hole[hole_start_idx:] + hole[:hole_start_idx]
        best_i, best_d = (0, float('inf'))
        hx, hy = hp[0]
        for i, (rx, ry) in enumerate(ring):
            d = (rx - hx) ** 2 + (ry - hy) ** 2
            if d < best_d:
                best_d, best_i = (d, i)
        bridge_point = ring[best_i]
        new_ring = ring[:best_i + 1] + hp + [hp[0]] + [bridge_point] + ring[best_i + 1:]
        ring = new_ring
    return ring

def triangulate_polygon(polygon):
    exterior = list(polygon.exterior.coords)
    holes = [list(interior.coords) for interior in polygon.interiors]
    if holes:
        ring = _bridge_holes(exterior, holes)
    else:
        ring = exterior[:-1] if exterior[0] == exterior[-1] else list(exterior)
    area2 = sum((ring[i][0] * ring[(i + 1) % len(ring)][1] - ring[(i + 1) % len(ring)][0] * ring[i][1] for i in range(len(ring))))
    if area2 < 0:
        ring = ring[::-1]
    idx = list(range(len(ring)))
    triangles = []
    guard = 0
    max_guard = len(ring) * len(ring) + 10
    while len(idx) > 3 and guard < max_guard:
        guard += 1
        ear_found = False
        n = len(idx)
        for k in range(n):
            i0, i1, i2 = (idx[(k - 1) % n], idx[k], idx[(k + 1) % n])
            a, b, c = (ring[i0], ring[i1], ring[i2])
            if _cross(a, b, c) <= 0:
                continue
            is_ear = True
            for j in idx:
                if j in (i0, i1, i2):
                    continue
                if _point_in_triangle(ring[j], a, b, c):
                    is_ear = False
                    break
            if is_ear:
                triangles.append((a, b, c))
                idx.pop(k)
                ear_found = True
                break
        if not ear_found:
            break
    if len(idx) == 3:
        a, b, c = (ring[idx[0]], ring[idx[1]], ring[idx[2]])
        triangles.append((a, b, c))
    return triangles

def extrude_polygon_to_triangles(polygon, z0, z1):
    tris_2d = triangulate_polygon(polygon)
    mesh_tris = []
    for a, b, c in tris_2d:
        mesh_tris.append(((a[0], a[1], z1), (b[0], b[1], z1), (c[0], c[1], z1)))
        mesh_tris.append(((a[0], a[1], z0), (c[0], c[1], z0), (b[0], b[1], z0)))
    rings = [list(polygon.exterior.coords)] + [list(i.coords) for i in polygon.interiors]
    for ring_i, ring in enumerate(rings):
        is_exterior = ring_i == 0
        pts = ring[:-1] if ring[0] == ring[-1] else ring
        n = len(pts)
        for i in range(n):
            p0 = pts[i]
            p1 = pts[(i + 1) % n]
            v0b, v1b = ((p0[0], p0[1], z0), (p1[0], p1[1], z0))
            v0t, v1t = ((p0[0], p0[1], z1), (p1[0], p1[1], z1))
            if is_exterior:
                mesh_tris.append((v0b, v1b, v1t))
                mesh_tris.append((v0b, v1t, v0t))
            else:
                mesh_tris.append((v1b, v0b, v0t))
                mesh_tris.append((v1b, v0t, v1t))
    return mesh_tris

def build_stamp_triangles(brim_poly, design_poly, brim_height_mm, design_height_mm, px_to_mm):
    from shapely.affinity import scale as shp_scale

    def to_mm(p):
        return shp_scale(p, xfact=px_to_mm, yfact=px_to_mm, origin=(0, 0))
    brim_mm = to_mm(brim_poly)
    design_geoms = design_poly.geoms if hasattr(design_poly, 'geoms') else [design_poly]
    design_mm = [to_mm(g) for g in design_geoms]
    triangles = []
    brim_pieces = brim_mm.geoms if hasattr(brim_mm, 'geoms') else [brim_mm]
    for piece in brim_pieces:
        triangles.extend(extrude_polygon_to_triangles(piece, 0.0, brim_height_mm))
    seam_overlap = min(0.05, brim_height_mm * 0.1)
    z0 = brim_height_mm - seam_overlap
    z1 = brim_height_mm + design_height_mm
    for g in design_mm:
        triangles.extend(extrude_polygon_to_triangles(g, z0, z1))
    return triangles

def write_binary_stl(triangles, path_or_buffer):
    import struct
    tris = np.asarray(triangles, dtype=np.float32).reshape(-1, 3, 3)
    n = len(tris)
    v0, v1, v2 = (tris[:, 0], tris[:, 1], tris[:, 2])
    normals = np.cross(v1 - v0, v2 - v0)
    lens = np.linalg.norm(normals, axis=1, keepdims=True)
    lens[lens == 0] = 1
    normals = (normals / lens).astype(np.float32)
    rec = np.zeros(n, dtype=np.dtype([('n', '<f4', 3), ('v', '<f4', (3, 3)), ('attr', '<u2')]))
    rec['n'] = normals
    rec['v'] = tris
    header = b'\x00' * 80 + struct.pack('<I', n)
    if hasattr(path_or_buffer, 'write'):
        path_or_buffer.write(header)
        path_or_buffer.write(rec.tobytes())
    else:
        with open(path_or_buffer, 'wb') as f:
            f.write(header)
            f.write(rec.tobytes())

def _rasterize_polygon(polygon_or_multi, width_px, height_px, minx, miny, sx, sy):
    from PIL import Image as PILImage, ImageDraw
    img = PILImage.new('1', (width_px, height_px), 0)
    draw = ImageDraw.Draw(img)
    geoms = polygon_or_multi.geoms if hasattr(polygon_or_multi, 'geoms') else [polygon_or_multi]
    for g in geoms:
        if g.is_empty:
            continue
        pts = [((x - minx) * sx, (y - miny) * sy) for x, y in g.exterior.coords]
        draw.polygon(pts, fill=1)
        for interior in g.interiors:
            ipts = [((x - minx) * sx, (y - miny) * sy) for x, y in interior.coords]
            draw.polygon(ipts, fill=0)
    mask = np.array(img, dtype=bool)
    from scipy import ndimage
    struct = np.ones((3, 3), dtype=bool)
    mask = ndimage.binary_closing(mask, structure=struct)
    mask = ndimage.binary_opening(mask, structure=struct)
    return mask

def build_stamp_triangles_heightfield(brim_poly, design_poly, brim_height_mm, design_height_mm, px_to_mm, grid_resolution=700):
    minx, miny, maxx, maxy = brim_poly.bounds
    w_mm = (maxx - minx) * px_to_mm
    h_mm = (maxy - miny) * px_to_mm
    if w_mm >= h_mm:
        W = grid_resolution
        H = max(2, int(round(grid_resolution * h_mm / w_mm)))
    else:
        H = grid_resolution
        W = max(2, int(round(grid_resolution * w_mm / h_mm)))
    sx = W / (maxx - minx)
    sy = H / (maxy - miny)
    cell_mm_x = w_mm / W
    cell_mm_y = h_mm / H
    brim_mask = _rasterize_polygon(brim_poly, W, H, minx, miny, sx, sy)
    design_mask = _rasterize_polygon(design_poly, W, H, minx, miny, sx, sy)
    design_mask = design_mask & brim_mask
    height = np.zeros((H, W), dtype=np.float64)
    height[brim_mask] = brim_height_mm
    height[design_mask] = brim_height_mm + design_height_mm

    def gx(i):
        return minx * px_to_mm + i * cell_mm_x

    def gy(j):
        return miny * px_to_mm + j * cell_mm_y
    triangles = []
    solid_rows, solid_cols = np.nonzero(height > 0)
    for j, i in zip(solid_rows.tolist(), solid_cols.tolist()):
        h = height[j, i]
        x0, x1 = (gx(i), gx(i + 1))
        y0, y1 = (gy(j), gy(j + 1))
        triangles.append(((x0, y0, h), (x1, y0, h), (x1, y1, h)))
        triangles.append(((x0, y0, h), (x1, y1, h), (x0, y1, h)))
        triangles.append(((x0, y0, 0), (x1, y1, 0), (x1, y0, 0)))
        triangles.append(((x0, y0, 0), (x0, y1, 0), (x1, y1, 0)))
    padded = np.zeros((H + 2, W + 2), dtype=np.float64)
    padded[1:-1, 1:-1] = height

    def add_wall(x0, y0, x1, y1, h_lo, h_hi, flip):
        a, b = ((x0, y0), (x1, y1))
        if flip:
            a, b = (b, a)
        p0 = (a[0], a[1], h_lo)
        p1 = (b[0], b[1], h_lo)
        p2 = (b[0], b[1], h_hi)
        p3 = (a[0], a[1], h_hi)
        triangles.append((p0, p1, p2))
        triangles.append((p0, p2, p3))
    rows, cols = np.nonzero(height >= 0)
    for j in range(H):
        for i in range(W + 1):
            h_left = padded[j + 1, i]
            h_right = padded[j + 1, i + 1]
            if h_left != h_right:
                x = gx(i)
                y0, y1 = (gy(j), gy(j + 1))
                lo, hi = (min(h_left, h_right), max(h_left, h_right))
                if lo == hi:
                    continue
                flip = h_right > h_left
                add_wall(x, y0, x, y1, lo, hi, flip)
    for j in range(H + 1):
        for i in range(W):
            h_top = padded[j, i + 1]
            h_bot = padded[j + 1, i + 1]
            if h_top != h_bot:
                y = gy(j)
                x0, x1 = (gx(i), gx(i + 1))
                lo, hi = (min(h_top, h_bot), max(h_top, h_bot))
                if lo == hi:
                    continue
                flip = h_bot > h_top
                add_wall(x0, y, x1, y, lo, hi, not flip)
    return triangles

def dedupe_triangles(triangles, tol=6):
    seen = set()
    result = []
    for t in triangles:
        keyset = frozenset((tuple((round(c, tol) for c in v)) for v in t))
        if keyset in seen:
            continue
        seen.add(keyset)
        result.append(t)
    return result

def close_boundary_gaps(triangles, tol=6):
    from collections import defaultdict

    def key(p):
        return (round(p[0], tol), round(p[1], tol), round(p[2], tol))
    edge_count = defaultdict(int)
    for t in triangles:
        for i in range(3):
            a, b = (key(t[i]), key(t[(i + 1) % 3]))
            ek = (a, b) if a < b else (b, a)
            edge_count[ek] += 1
    boundary_edges = [e for e, c in edge_count.items() if c == 1]
    if not boundary_edges:
        return triangles
    adjacency = defaultdict(list)
    for a, b in boundary_edges:
        adjacency[a].append(b)
        adjacency[b].append(a)
    visited = set()
    extra_triangles = []
    for start in list(adjacency.keys()):
        if start in visited:
            continue
        loop = [start]
        visited.add(start)
        cur = start
        prev = None
        while True:
            nxts = [n for n in adjacency[cur] if n != prev]
            nxts = [n for n in nxts if n not in visited or n == start]
            if not nxts:
                break
            nxt = nxts[0]
            if nxt == start and len(loop) >= 3:
                break
            if nxt in visited:
                break
            loop.append(nxt)
            visited.add(nxt)
            prev, cur = (cur, nxt)
        if len(loop) >= 3:
            anchor = loop[0]
            for i in range(1, len(loop) - 1):
                extra_triangles.append((anchor, loop[i], loop[i + 1]))
    return triangles + extra_triangles

def build_stamp_triangles_cdt(brim_poly, design_poly, brim_height_mm, design_height_mm, px_to_mm, seam_overlap_mm=0.05):
    import shapely
    from shapely.affinity import scale as shp_scale
    from shapely.geometry.polygon import orient as _orient

    def to_mm(g):
        return shp_scale(g, xfact=px_to_mm, yfact=px_to_mm, origin=(0, 0))
    chunks = []

    def add_solid(poly_mm, z0, z1):
        tris = shapely.constrained_delaunay_triangles(poly_mm)
        coords = shapely.get_coordinates(tris)
        if len(coords):
            tri_xy = coords.reshape(-1, 4, 2)[:, :3, :]
            ax, ay = (tri_xy[:, 0, 0], tri_xy[:, 0, 1])
            bx, by = (tri_xy[:, 1, 0], tri_xy[:, 1, 1])
            cx, cy = (tri_xy[:, 2, 0], tri_xy[:, 2, 1])
            cw = (bx - ax) * (cy - ay) - (by - ay) * (cx - ax) < 0
            tri_xy[cw] = tri_xy[cw][:, [0, 2, 1], :]
            top = np.dstack([tri_xy, np.full(tri_xy.shape[:2] + (1,), z1)])
            bot = np.dstack([tri_xy[:, [0, 2, 1], :], np.full(tri_xy.shape[:2] + (1,), z0)])
            chunks.append(top)
            chunks.append(bot)
        geoms = poly_mm.geoms if hasattr(poly_mm, 'geoms') else [poly_mm]
        for g in geoms:
            g = _orient(g, sign=1.0)
            for ring in [g.exterior] + list(g.interiors):
                pts = np.asarray(ring.coords)
                if len(pts) > 1 and np.allclose(pts[0], pts[-1]):
                    pts = pts[:-1]
                if len(pts) < 3:
                    continue
                p0 = pts
                p1 = np.roll(pts, -1, axis=0)
                z0c = np.full((len(pts), 1), z0)
                z1c = np.full((len(pts), 1), z1)
                v0b = np.hstack([p0, z0c])
                v1b = np.hstack([p1, z0c])
                v0t = np.hstack([p0, z1c])
                v1t = np.hstack([p1, z1c])
                chunks.append(np.stack([v0b, v1b, v1t], axis=1))
                chunks.append(np.stack([v0b, v1t, v0t], axis=1))
    add_solid(to_mm(brim_poly), 0.0, brim_height_mm)
    add_solid(to_mm(design_poly), brim_height_mm - seam_overlap_mm, brim_height_mm + design_height_mm)
    if not chunks:
        return np.zeros((0, 3, 3))
    return np.concatenate(chunks, axis=0)
`,
"configurator_core.py": String.raw`import json, math
import numpy as np
from PIL import Image as PILImage
import pipeline_web as pw
MM_PER_IN = 25.4
LINE_WEIGHT_MM = 0.46
MIN_FEATURE_MM = 1.5 * 0.352778
FORCED_WEIGHT_MM = MIN_FEATURE_MM * 1.1
BRIM_MARGIN_MM = 2.5
BRIM_HEIGHT_MM = 0.5
DESIGN_HEIGHT_MM = 0.7
MAX_SIDE_IN = 9.5
MIN_SIDE_IN = 0.5
TIER_SIDES = [4.0 + i * (MAX_SIDE_IN - 4.0) / 8 for i in range(9)]
TIER_AREAS = [round(s * s, 2) for s in TIER_SIDES]
TIER_PRICES = [round(9.99 + 5 * i, 2) for i in range(9)]

def tier_for(area_in2):
    for i, a in enumerate(TIER_AREAS):
        if area_in2 <= a + 1e-09:
            return i
    return None

def load_bw(img_path, target_width_mm):
    src = PILImage.open(img_path)
    has_alpha = src.mode in ('RGBA', 'LA') or 'transparency' in src.info
    if has_alpha:
        rgba = np.array(src.convert('RGBA'))
        if rgba[:, :, 3].std() > 5 and rgba[:, :, :3].max() < 10:
            alpha = rgba[:, :, 3].astype(np.float64) / 255.0
            img = PILImage.fromarray((255.0 * (1 - alpha)).astype(np.uint8), mode='L')
        else:
            bg = PILImage.new('RGBA', src.size, (255, 255, 255, 255))
            img = PILImage.alpha_composite(bg, src.convert('RGBA')).convert('L')
    else:
        img = src.convert('L')
    arr = np.array(img)
    ys, xs = np.nonzero(arr < 128)
    if len(xs) == 0:
        raise ValueError('No artwork found -- the image looks blank. Use dark lines on a light background.')
    ink = float((arr < 128).mean())
    if ink > 0.45:
        raise ValueError('This looks like a solid/filled image, not line art. Upload dark LINES on a light background (outlines only), or contact us for a filled-design quote.')
    pad = 4
    img = img.crop((max(0, xs.min() - pad), max(0, ys.min() - pad), min(img.width, xs.max() + pad + 1), min(img.height, ys.max() + pad + 1)))
    if img.width < 300 and img.height < 300:
        raise ValueError('Image resolution is too low (artwork under 300 px). Upload a larger or sharper file.')
    cap = min(1600, max(800, int(target_width_mm / 0.05)))
    if img.width > cap:
        img = img.resize((cap, max(1, int(img.height * cap / img.width))), PILImage.LANCZOS)
    return img

def generate(img_path, overall_width_in, out_stl='/tmp/output.stl', progress=None):
    say = progress or (lambda pct, msg: None)
    if not MIN_SIDE_IN <= overall_width_in <= MAX_SIDE_IN:
        raise ValueError(f'Width must be between {MIN_SIDE_IN} and {MAX_SIDE_IN} inches.')
    design_w_mm = overall_width_in * MM_PER_IN - 2 * BRIM_MARGIN_MM
    if design_w_mm <= 2:
        raise ValueError('That width is too small for this design.')
    say(5, 'Loading image...')
    img = load_bw(img_path, design_w_mm)
    px_to_mm = design_w_mm / img.width
    mask = np.array(img) < 128
    say(20, 'Tracing lines...')
    junctions = []
    strokes = pw.skeletonize_lineart_web(mask, FORCED_WEIGHT_MM, px_to_mm, min_feature_mm=FORCED_WEIGHT_MM, junctions_out=junctions)
    strokes = strokes.simplify(0.0, preserve_topology=True)
    say(50, 'Smoothing junctions...')
    half_w = FORCED_WEIGHT_MM / px_to_mm / 2.0
    strokes = pw.fillet_junctions(strokes, half_w * 0.5, junction_points=junctions)
    strokes = strokes.buffer(0)
    strokes = pw.drop_degenerate_vertices(strokes)
    say(70, 'Building base plate...')
    brim_poly, design_poly = pw.add_brim(strokes, BRIM_MARGIN_MM / px_to_mm)
    minx, miny, maxx, maxy = brim_poly.bounds
    w_in = (maxx - minx) * px_to_mm / MM_PER_IN
    h_in = (maxy - miny) * px_to_mm / MM_PER_IN
    if max(w_in, h_in) > MAX_SIDE_IN + 0.03:
        raise ValueError(f'At this width the stamp would be {w_in:.2f}" x {h_in:.2f}". Max is {MAX_SIDE_IN}" on either side -- reduce the width.')
    w_in, h_in = (min(w_in, MAX_SIDE_IN), min(h_in, MAX_SIDE_IN))
    area = w_in * h_in
    tier = tier_for(area)
    say(82, 'Building 3D model...')
    tris = pw.build_stamp_triangles_cdt(brim_poly, design_poly, BRIM_HEIGHT_MM, DESIGN_HEIGHT_MM, px_to_mm)
    pw.write_binary_stl(tris, out_stl)
    return {'width_in': round(w_in, 2), 'height_in': round(h_in, 2), 'area_in2': round(area, 1), 'tier': tier, 'tier_index': tier, 'price': TIER_PRICES[tier], 'tier_max_area': TIER_AREAS[tier], 'n_triangles': len(tris), 'line_weight_mm': round(FORCED_WEIGHT_MM, 3)}
`
};
